import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  OnDestroy
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { PrescriberDetailsSimple } from '@module-claims/models/prescriber.interface';
import { ClaimsService } from '@module-claims/services/claims.service';
import { IAsyncData } from '@module-claims/store/claims.state';
import {
  PrescriberCEAssociationRemovalModalClose,
  PrescriberCEAssociationRemovalModalSave
} from '@module-claims/store/prescriber.actions';
import { Store } from '@ngxs/store';
import { getValidationMessage } from '@utils-global/validation-messages';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-ce-association-removal-modal',
  templateUrl: './ce-association-removal-modal.component.html',
  styleUrls: ['./ce-association-removal-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CeAssociationRemovalModalComponent implements OnInit, OnDestroy {
  @Input() npi!: string;

  form!: UntypedFormGroup;

  prescriberDetails$!: Observable<IAsyncData<PrescriberDetailsSimple>>;

  constructor(
    private _fb: UntypedFormBuilder,
    private _store: Store,
    private _claimsService: ClaimsService
  ) {
    this.prescriberDetails$ = this._claimsService.prescriberDetails$;
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.close();
  }

  close(): void {
    this._store.dispatch(new PrescriberCEAssociationRemovalModalClose());
  }

  save(): void {
    if (this.form.pristine || this.form.invalid) {
      for (const key of Object.keys(this.form.controls)) {
        this.form.get(key)?.markAsDirty();
      }
      return;
    }

    this._store.dispatch(
      new PrescriberCEAssociationRemovalModalSave({
        action: 'remove',
        npi: this.npi,
        ceId:
          this.ceId.value && (this.ceId.value as string).trim().toUpperCase()
      })
    );
  }

  private initForm(): void {
    this.form = this._fb.group({
      ceId: [null, Validators.required]
    });
  }

  getControlErrorMsg(control: UntypedFormControl): string {
    return getValidationMessage(control);
  }

  get ceId(): UntypedFormControl {
    return this.form.get('ceId') as UntypedFormControl;
  }
}
